<template>
  <div class="px-5">
    <h4 class="form-section__field text-center">
      <span
        v-for="(item, index) in $root.t('contactUs.desc')"
        :key="index"
      >
        {{ item }} <br>
      </span>
    </h4>
    <div class="form-section row g-3">
      <div class="col-md-6">
        <AppInput
          name="Contact.Email"
          :label="$root.t('step3.email')"
          rules="required|email"
        >
          <input
            v-model="form.email"
            class="form-control"
            autocomplete="email"
          >
        </AppInput>
      </div>

      <div class="col-md-6">
        <AppInput
          name="Contact.Name"
          :label="$root.t('contactUs.name')"
        >
          <input
            v-model="form.name"
            class="form-control"
            autocomplete="name"
          >
        </AppInput>
      </div>

      <div class="col-md-6">
        <AppInput
          name="Contact.Age"
          :label="$root.t('contactUs.age')"
        >
          <input
            v-model="form.age"
            class="form-control"
            disabled
            readonly
          >
        </AppInput>
      </div>

      <div class="col-md-6">
        <AppInput
          name="Contact.CountryOfResidence"
          :label="$root.t('contactUs.residenceCountry')"
        >
          <input
            v-model="countryOfResidence"
            class="form-control"
            disabled
            readonly
          >
        </AppInput>
      </div>

      <div class="col-md-6">
        <span
          v-for="(item, index) in $root.t('contactUs.numberDesc')"
          :key="index"
        >
          {{ item }}. <br>
        </span>
      </div>

      <div class="col-md-6">
        <span />
      </div>

      <div class="col-md-6">
        <AppInput
          name="Contact.CountryCode"
          :label="$root.t('contactUs.countryCode')"
        >
          <input
            v-model="countryCode"
            class="form-control"
            disabled
            readonly
          >
        </AppInput>
      </div>

      <div class="col-md-6">
        <AppInput
          name="Contact.Number"
          :label="$root.t('contactUs.number')"
          rules="required"
        >
          <input
            v-model="form.number"
            class="form-control"
            autocomplete="tel-national"
          >
        </AppInput>
      </div>

      <div class="col-md-12">
        <AppInput
          name="Contact.DateOfBirth"
          :label="$root.t('contactUs.contactTimeDesc')"
        >
          <input
            v-model="form.contactTime"
            type="datetime-local"
            class="form-control"
            aria-label="preferred Contact Date And Time"
          >
        </AppInput>
      </div>
    </div>
  </div>
</template>

<script>
import helper from '../../utils/helper.js'

export default {
  name: 'ContactUs',
  components: {},
  props: {
    form: { type: Object, required: true },
  },
  data() {
    return {
      details: this.$formData.policyHolder.details,
    }
  },
  computed: {
    countryOfResidence() {
      return this.details.residenceCountryId !== ''
        ? this.$optionData.residenceCountries.find((c) => c.value === this.details.residenceCountryId).text
        : ''
    },
    countryCode() {
      return this.details.residenceCountryId !== ''
        ? this.$optionData.countryCodes.find((c) => c.value === this.details.residenceCountryId).text
        : ''
    },
  },
  mounted() {
    this.form.email = this.$formData.policyHolder.contactDetails.emailAddress
    this.form.name = `${this.details.forename} ${this.details.surname}`
    this.form.age = helper.getAge(new Date(this.details.dateOfBirth))
    if (this.details.residenceCountryId !== '') {
      this.form.residenceCountryId = this.$optionData.residenceCountries.find(
        (c) => c.value === this.details.residenceCountryId,
      ).value

      this.form.countryCodeId = this.$optionData.countryCodes.find(
        (c) => c.value === this.details.residenceCountryId,
      ).value
    }
  },
  methods: {},
}
</script>
